<template>
	<div id='captura'>
		<div align="center">
			<button v-on:click="imprimir('estado-cuenta')"><b>Imprimir o crear PDF</b></button>
			<br><br>
		</div>
        

		<div id='estado-cuenta'>
			<div id='estado-ver' v-if='contratoSolo !=null'>
				<p align="center"><b>ESTADO DE CUENTA </b></p>
				<p align="center"><b>Al {{formateaFecha(hoy)}}</b></p>

				<br>
				<table class="table is-striped is-hoverable" align="center" border="2" cellspacing="10" v-for="contratos in contratoSolo">
				  <tbody v-model="leyenda = contratos.giro + ' - ' + contratos.familia + ' - ' + contratos.propiedad">
					<tr>
					<td>Giro:</td>
					<td><b>{{contratos.giro}}</b></td>
					</tr>
					<tr>
					<td>Renta mensual:</td>
					<td><b>$ {{formateaNumero(contratos.importeMes)}}</b></td>
					</tr>
					<tr>
					<td>Propiedad:</td>
					<td><b>({{contratos.id}}) {{contratos.propiedad}}</b></td>
					</tr>
					<tr>
					<td>Familia:</td>
					<td><b>{{contratos.familia}}</b></td>
					</tr>
					<tr>
					<td>Celular:</td>
					<td>{{contratos.celularInquilino}}</td>
					</tr>
					<tr>
					<td>Email:</td>
					<td>{{contratos.emailInquilino}}</td>
					</tr>
					<tr>					
					<td>Nombre Comercial:</td>
					<td><b>{{contratos.nombreComercial}}</b></td>
					</tr>
					<tr>
					<td>Inquilino:</td>
					<td>{{contratos.inquilino}}</td>
					</tr>
					<tr v-if="verStatus(contratos.status)">
					<td>Status:</td>
					<td><strong><font color="blue">{{contratos.status}}</font></strong></td>
					</tr>					
					<tr>
					<td>Fecha inicio contrato:</td>
					<td>{{formateaFecha(contratos.fechaInicio)}}</td>
					</tr>
					<tr>
					<td>Contrato Num:</td>
					<td>{{contratos.id}}{{pasaContrato(contratos.id)}}</td>
					</tr>
					<tr>
					<td>Saldo inicial</td>
					<td>$ {{formateaNumero(contratos.saldoInicial)}} al {{formateaFecha(contratos.fechaSaldoInicial)}}</td>
					</tr>
					<tr>
					<td>Adeudo actual: </td>
					<td><b>$ {{formateaNumero(saldoTotal)}}</b></td>
					</tr>
				  </tbody>
				</table>

			</div>
			<span v-else>Cargando contrato</span>

			<div>
				<br>
				<p align="center">
					<b> 
					 Del: <input type="date" id="de" v-on:change='rangos()' v-bind="fecha1" >
					 Al:  <input type="date" id="al" v-on:change='rangos()' v-bind="fecha2" >
					</b>
					&nbsp&nbsp&nbsp&nbsp Concepto 
					<select id="losConceptos" text="Concepto" v-on:change='rangos()'>
					  <option value="Todos" selected="true">Todos</option>
					  <option value="Consumo AGUA">Consumo AGUA</option>
					  <option value="Consumo LUZ">Consumo LUZ</option>
					</select>
				<br>
				<br>
					<b>Del &nbsp&nbsp</b> {{formateaFecha(fecha1)}}  <b>&nbsp&nbsp&nbsp&nbsp al &nbsp&nbsp&nbsp&nbsp</b> {{formateaFecha(fecha2)}}
		
				</p>
			</div>
			<br>

			<div name='contrato-edo' align="center" v-if='movimientos4 !=null'>
				<table  border="2" cellspacing="10" class="table is-striped is-hoverable" >
				  <tbody>
					<tr>
						<th>fecha</th>
						<th>tipo/folio</th>
						<th>concepto</th>
						<th><p align="right">cargos</p></th>
						<th><p align="right">abonos</p></th>
						<th>forma de pago</th>
						<th><p align="right">saldo</p></th>
					</tr>

					<tr v-for="(movi, indice) in movimientos4" >
						<td>{{formateaFecha(movi.fecha)}}</td>
						<td v-if="movi.tipo == 'PAGO'" ><b>{{movi.tipo}}</b><br>{{movi.ids}}</td>
						<td v-if="movi.tipo != 'PAGO'" >{{movi.tipo}}<br>{{movi.ids}}</td>

						<td>{{movi.concepto}}<br>
							{{movi.referencia}}<br>
							{{movi.comentario}}
						</td>
						<td><p align="right" v-if="movi.importe >= 0">${{formateaNumero(movi.importe)}}</p></td>
						<td><p align="right" v-if="movi.importe < 0"><b>${{formateaNumero(movi.importe)}}</b></p></td>
						<td>{{movi.formaDePago}}<br>
							<a v-on:click="verFoto(movi.ids)" >{{movi.recibo}} </a>
							<br>
							<img v-bind:src="'https://directodo.com/Rentus/accesosdb/recibosrentus/' + movi.direccionFoto" alt=" " width="250" height="250" id ="lafoto" v-if="movi.recibo !='' && cualFotoId == movi.ids" >
						</td>
						<td><p align="right">${{formateaNumero(movi.acum)}}</p></td>
					</tr>
				  </tbody>
				</table>
                {{leyenda}}
				<br>
			</div>
		</div>

		<div>
			<br><br>

			<button v-on:click="imprimir('estado-cuenta')"><b>Imprimir Estado de Cuenta o crear PDF </b></button>
			<br><br>
		</div>

	</div>
</template>

<script>

	import axios from 'axios';
	export default{
		name:'contrato-estado',
		prueba:'funciona',
		mounted(){
			this.hoy = new Date(); 
			this.entrar();
		},
		props:['vector', 'cualContrato'],
		data(){
			return{
				id: null,
				contratoSolo: null,	
				movimientos: null,
				movimientos2: null,
				movimientos3: null,
				saldo: 0,
				saldoInicial: 0,
				saldoTotal: 0,
				numero: 0,
				hoy: '',
				numContrato: 0,
				mailInquilino1:'',
				fecha1:'',
				fecha2:'',
                leyenda:'',
                cualFotoId:''		
			}
		},
		methods:{
			enviar(){

				var elMail = document.getElementById('pormail').value;
				var desde = document.getElementById('de').value ;
				var hasta = document.getElementById('al').value ;

                var liga = 'https://www.directodo.com/Rentus/accesosdb/enviarEdoMail.php?edcpm=' + this.mailInquilino1 + '&ecde=' + this.numContrato + '&fede=' + desde + '&feha=' + hasta + '&otroMail=' + elMail

		        /*axios.get(liga)
		               .then((respue) => {
			                if (respue.statusText == 'OK'){
			                    alert('\n\n     Estado de cuenta enviado a: \n\n     ' + elMail);
			                }
		                })
		                .catch((error) =>{
		                    alert('No se pudo enviar el estado de cuenta  ' + error);
		                }
		                );
                        */

			},

			pasaContrato(contrat){
				this.numContrato = contrat;
			},

			entrar(){
				// checa si tiene autorizacion
                console.log("guv " + this.vector);
		  		if(!this.vector.includes('MASTERGGUV')){
			  		if(!this.vector.includes('Contratos Ver detalle')){
			  			document.getElementById('captura').hidden = true;
			  			alert('Seccion no autorizada');
			  			return;
			  		}
			  	}

			  	// trae la informacion del contrato con el número del contrato
				//this.id=this.$route.params.id;
                this.id = this.cualContrato;	
				axios.get('https://directodo.com/Rentus/accesosdb/leeUnContrato.php?id='+this.id)
	  		         .then((respue) => {
	  		     		this.contratoSolo = respue.data;// pasa de json a array

	  		     		// obtiene el saldo inicial
	  		     		this.saldoInicial = this.contratoSolo[0].saldoInicial;
	  		     		this.mailInquilino1 = this.contratoSolo[0].emailInquilino;
						document.getElementById('pormail').value = this.mailInquilino1;
	  			 	 });
					
				// trae los movimientos del contrato en orden de edo de cuenta
				axios.get('https://directodo.com/Rentus/accesosdb/leeEstadoDeCuenta.php?idc='+this.id)
	  		         .then((respues) => {
	  		     		this.movimientos = respues.data; 

	   					// copia movimientos a un nuevo array llamado movimientos2 y luego le agrega un campo adicional con el acumulado
					    this.movimientos2 = this.movimientos.map(a => ({...a}));

					    // primero agrega el saldo inicial del control del sistema
					    let acum = 0;
					    var primerRegistro = true;
					    this.movimientos2.forEach(p => {
					    	if(primerRegistro){
						        acum += parseFloat(p.importe) + parseFloat(this.saldoInicial);
						        primerRegistro = false;
					    	}else{
					    		acum += parseFloat(p.importe);
					    	}

					        p.acum = acum; // agrego esta propiedad para guardar el acumulado
					    });

					    // obtiene el saldo total
					    this.saldoTotal = this.movimientos2[this.movimientos2.length-1].acum;

					    // movimientos2 siempre tendrá TODOS los movimientos
					    // y movimientos3 será reactivo para filtrar
					    this.movimientos3 = this.movimientos2;

		  			 	// pone las fechas actuales en la form
		  			 	var hoy = new Date();
		  			 	var haceUnMes = hoy;

	 	  			 	document.getElementById('al').valueAsDate = hoy;

		  			 	// calcula la fecha de hace un año
		  			 	haceUnMes.setMonth(haceUnMes.getMonth() - 12);
	 	  			 	document.getElementById('de').valueAsDate = haceUnMes;

	 	  			 	this.fecha1 = hoy;
	 	  			 	this.fecha2 = haceUnMes;
   
   		  			 	this.rangos();

	  			 	 });

	  		},

	  		verStatus: function (status){
	  			if (status == "RENTADO"){
	  				return false;	  				
	  			}else return true;
	  		},

	  		verFoto: function (cual){
                this.cualFotoId = cual;
	  		},
  
			formateaFecha: function (fecha) {

				var d = new Date(fecha); 
				if (Date.parse(d)){
					// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
					d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
					//d.setHours(0);
					var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
					d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
					return d

				}else{
					return "sin fecha";
				}
			},

		    formateaNumero(valor1) {
		        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
		    },

			rangos(){
				// pasa las fechas a milisegundos para compararlas
				var desde = document.getElementById('de').value ;
				var hasta = document.getElementById('al').value ;

				var de = new Date(desde);
				// lo ajusta a la zona horaria local:
				de.setMinutes(de.getMinutes() + de.getTimezoneOffset());
				de.setHours(0);// para que no tome la hora que trae

				var al = new Date(hasta); 
				// lo ajusta a la zona horaria local:
				al.setMinutes(al.getMinutes() + al.getTimezoneOffset());
				al.setHours(0);// para que no tome la hora que trae

				var dems = de.getTime(); // en milisegundos				
				var alms = al.getTime(); // en milisegundos

				// solo pasa los registros que están dentro de las fechas
				this.movimientos3 = this.movimientos2.filter(function(movimiento) {
					// toma cada registro y su fecha la pasa a milisegundos
					var lafecha2 = new Date(movimiento.fecha); 
					lafecha2.setMinutes(lafecha2.getMinutes() + lafecha2.getTimezoneOffset());
					lafecha2.setHours(0);// le pone las horas en ceros
					var lafechams = lafecha2.getTime();

					if(lafechams >= dems && lafechams <= alms){
						var concep = document.getElementById("losConceptos").value;
						if(concep != "Todos"){
							if(movimiento.concepto.includes(concep)){
								movimiento.acum = 0;
								return movimiento;
							} 
						}else return movimiento;
					}

				});

				// actualiza letretos de fechas
				this.fecha1 = de;
				this.fecha2 = al;
	   			
			},
		  	imprimir: function(divName) {
			     var printContents = document.getElementById(divName).innerHTML;
			     var originalContents = document.body.innerHTML;
			     document.body.innerHTML = printContents;
			     window.print();
			},
			

		},
		computed:
		{
			movimientos4: function(){
				return this.movimientos3;
			}
		}
		

	}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/Contrato-estado.vue